import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { EnterpriseContextService } from '../../../services/enterprise-context.service'
import { EnterpriseConfig } from '../../../config/enterprise.config'

@Component({
    selector: 'app-admin-enterprise-settings-page',
    templateUrl: './admin-enterprise-settings-page.component.html',
    styleUrls: ['./admin-enterprise-settings-page.component.scss'],
})
export class AdminEnterpriseSettingsPageComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = []

    currentEnterprise: EnterpriseConfig | null = null
    loading = false

    constructor(public enterpriseContext: EnterpriseContextService) {}

    ngOnInit(): void {
        const entSub = this.enterpriseContext.currentEnterprise$.subscribe((enterprise) => {
            this.currentEnterprise = enterprise
        })
        this.subscriptions.push(entSub)
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe())
    }

    getHomepageUrl(): string {
        if (!this.currentEnterprise) return ''

        // For local development, use the enterprise path
        if (window.location.hostname === 'localhost' || window.location.hostname.includes('localhost')) {
            return `/enterprise/${this.currentEnterprise.key}`
        }

        // For production, use the enterprise domain
        return `https://${this.currentEnterprise.domain}`
    }

    openHomepage(): void {
        const url = this.getHomepageUrl()
        if (url) {
            window.open(url, '_blank')
        }
    }

    copyToClipboard(text: string): void {
        navigator.clipboard.writeText(text)
    }
}
